// extracted by mini-css-extract-plugin
module.exports = {"badge-count":"badge-count","badgeCount":"badge-count","uig-button":"uig-button","uigButton":"uig-button","brand-TP":"brand-TP","brandTp":"brand-TP"};